export default __webpack_public_path__ + "images/5f47b82841721ab36e63643a53fd192f.svg";